var map = {
	"./at_risk.svg": "fe37",
	"./champions.svg": "333e",
	"./inactive.svg": "7e55",
	"./loyal.svg": "1bc6",
	"./need_attention.svg": "2c35",
	"./recent.svg": "9637"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2345";